import axios from 'axios';
import { GET_SOCIETES, ADD_SOCIETE, DELETE_SOCIETE, SOCIETES_LOADING, CLEAR_SOCIETES } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { ISociete } from '../../types/interfaces';

export const getSocietes = (ids: number[] = []) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: SOCIETES_LOADING
  });
  axios
    .get('/api/societes', {...tokenConfig(getState), params: {ids}})
    .then(res =>
      dispatch({
        type: GET_SOCIETES,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getAllSocietes = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: SOCIETES_LOADING
  });
  axios
    .get('/api/societes/all', tokenConfig(getState))
    .then(res =>
      dispatch({
        type: GET_SOCIETES,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addSociete = (societe: ISociete) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/societes', societe, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: ADD_SOCIETE,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const deleteSociete = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/societes/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_SOCIETE,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setSocietesLoading = () => {
  return {
    type: SOCIETES_LOADING
  };
};

export const clearSocietes = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_SOCIETES
  })
};